import { QueryClient } from "@tanstack/react-query";

// Module-level so non-React code (http() in api.ts) can reach the cache —
// e.g. to flip auth to logged-out on a 401.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
